import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './stili/tokens.css';

const radice = document.getElementById('radice');
if (!radice) throw new Error('Elemento #radice non trovato in index.html');

createRoot(radice).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
